import React from "react";
import splash from "../assets/images/footer/footer_banner1.png";
import poolspa from "../assets/images/footer/footer_banner2.png";
import hayward from "../assets/images/footer/footer_banner3.png";

function Footer() {
  const banners = [
    { id: 1, image: splash, alt: "Splash Pool Maintenance Expert" },
    { id: 2, image: poolspa, alt: "Pool and Spa Direct" },
    { id: 3, image: hayward, alt: "Hayward" },
  ];

  return (
    <footer className="bg-slate-900 text-slate-400">
      {/* Partners Section */}
      <div className="border-b border-slate-800/50">
        <div className="container mx-auto px-6 py-10 md:py-12">
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 lg:gap-20">
            {banners.map((banner) => (
              <div
                key={banner.id}
                className="group relative h-10 md:h-16 w-32 md:w-48 transition-all duration-300"
              >
                <img
                  src={banner.image}
                  alt={banner.alt}
                  className="h-full w-full object-contain filter grayscale invert opacity-40 group-hover:opacity-100 group-hover:grayscale-0 transition-all duration-500"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main Footer Info */}
      <div className="container mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-start">
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left space-y-6">
            <h2 className="text-3xl md:text-4xl font-black text-white tracking-tighter">
              WATER<span className="text-blue-500">PIA</span>
            </h2>
            <p className="text-slate-500 max-w-md font-light leading-relaxed text-sm md:text-base">
              워터피아는 최상의 수질과 프리미엄 수영장 솔루션을 통해 <br className="hidden md:block" />
              고객님의 공간에 새로운 가치를 선사하는 수영장 전문 기업입니다.
            </p>
            <div className="flex gap-4">
              <a
                href="tel:010-5113-4637"
                className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center text-white hover:bg-blue-600 transition-all duration-300 hover:scale-110 premium-shadow"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </a>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-8 text-center sm:text-left text-sm">
            <div className="space-y-5">
              <h3 className="text-white font-bold uppercase tracking-[0.2em] text-[10px] md:text-xs opacity-50">
                Contact Us
              </h3>
              <ul className="space-y-3 font-light">
                <li className="flex items-center justify-center sm:justify-start gap-3">
                  <span className="text-blue-500 font-bold">T.</span> 043-645-9061
                </li>
                <li className="flex items-center justify-center sm:justify-start gap-3">
                  <span className="text-blue-500 font-bold">F.</span> 043-645-9071
                </li>
                <li className="flex items-center justify-center sm:justify-start gap-3">
                  <span className="text-blue-500 font-bold">E.</span> haneaja@hanmail.net
                </li>
              </ul>
            </div>
            <div className="space-y-5">
              <h3 className="text-white font-bold uppercase tracking-[0.2em] text-[10px] md:text-xs opacity-50">
                Address
              </h3>
              <p className="font-light leading-relaxed">
                충북 제천시 의림대로 264
                <br className="sm:hidden" />
                (청전동)
              </p>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-800/50 flex flex-col md:flex-row justify-between items-center gap-8 text-[10px] md:text-xs uppercase tracking-widest font-medium text-slate-500">
          <div className="flex flex-wrap justify-center md:justify-start gap-x-6 gap-y-3 opacity-80">
            <span className="flex gap-2">
              <span className="text-slate-700">상호</span> 워터피아
            </span>
            <span className="flex gap-2">
              <span className="text-slate-700">대표자</span> 이돈균
            </span>
            <span className="flex gap-2">
              <span className="text-slate-700">등록번호</span> 304-09-21045
            </span>
          </div>
          <p className="opacity-60">© 2015-2024 WATERPIA. ALL RIGHTS RESERVED.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
